import { useEffect, useState } from 'react';
import {
	FormGroup,
	InputTextblock,
	Layout,
	Loader,
	RadioButton,
	SelectDropDown,
} from '../../../components';
import { useNavigate, useParams } from 'react-router-dom';
import { Tevent } from '../../../type/event';
import {
	getDataDetail,
	postDataQuestionerTransaction,
} from '../../../service/questionerService';
import { getDataDetailUniqueId } from '../../../service/eventService';
import Lottie from 'lottie-react';
import successAnimation from '../../../assets/lotties/animation-success.json';
import { getMyProfile } from '../../../service/usersService';
import { showMessage } from '../../../utls/message';
import { Tquestioner } from '../../../type/questioner';
import { TquestionerDetails } from '../../../type/questionerDetails';
import { Tusers } from '../../../type/users';
import { Toption } from '../../../type/option';

const QuestionerEventForm = () => {
	const { id, slug } = useParams();
	const [questioner, setQuestioner] = useState<Tquestioner | undefined>();
	const [questionnaireTransactionDetails, setQuestionnaireTransactionDetails] =
		useState<{ questionnaireDetail: TquestionerDetails; valueText: string }[]>(
			[]
		);
	const [event, setEvent] = useState<Tevent | undefined>();
	const [user, setUser] = useState<Tusers | undefined>();
	const [trainerList, setTrainerList] = useState<Toption[]>([]);
	const [selectTrainer, setSelectTrainer] = useState<Toption | undefined>();
	const [onSubmit, setOnSubmit] = useState(false);
	const [isLoading, setIsLoading] = useState(false);

	const navigator = useNavigate();

	const getDataQuestionerDetail = async (slug: string) => {
		try {
			setIsLoading(true);

			const response = await getDataDetail(slug);

			if (!response?.error) {
				const newQuestionTransactionDetail =
					response?.data.questionnaireDetails.map((item: any) => {
						return {
							questionnaireDetail: item,
							valueText: '',
						};
					});

				setQuestioner(response?.data);
				setQuestionnaireTransactionDetails(newQuestionTransactionDetail);
			}
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const getDataEventDetail = async (id: string) => {
		try {
			setIsLoading(true);

			const response = await getDataDetailUniqueId(id);

			if (!response?.error) {
				setEvent(response?.data);

				const items: Toption[] = [];
				response?.data.picList.map((item: any) => {
					items.push({
						label: item.users.fullName,
						value: item.users.id?.toString() || '0',
						data: item.users,
					});
				});
				setTrainerList(items);
			}
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	const getMyDataProfile = async () => {
		try {
			setIsLoading(true);

			const response = await getMyProfile();
			if (!response?.error) {
				setUser(response?.data);
			}
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	// Function to update valueText of a specific questionnaire detail
	const updateValueText = (index: number, newValueText: string) => {
		setQuestionnaireTransactionDetails((prevState) => {
			// Create a shallow copy of the state array
			const newState = [...prevState];

			// Create a shallow copy of the object at the specified index and update its valueText
			const updatedObject = { ...newState[index], valueText: newValueText };

			// Update the newState with the updated object
			newState[index] = updatedObject;

			// Return the updated state
			return newState;
		});
	};

	const handleSubmit = async () => {
		if (!selectTrainer) {
			showMessage(`Trainer belum dipilih`, 'error');
			return;
		}

		try {
			setIsLoading(true);

			const bodyRequest = {
				questionnaire: questioner,
				users: user,
				resource: 'EVENT',
				resourceId: `${event?.id}`,
				questionnaireTransactionDetails: questionnaireTransactionDetails,
				usersTo: selectTrainer.data,
			};

			const response = await postDataQuestionerTransaction(bodyRequest);
			if (response?.code === 200) {
				setOnSubmit(true);
			} else {
				showMessage(response?.message, 'error');
			}
		} catch (error) {
			console.log(error);
		} finally {
			setIsLoading(false);
		}
	};

	useEffect(() => {
		getMyDataProfile();

		if (slug) {
			getDataQuestionerDetail(slug);
		}

		if (id) {
			getDataEventDetail(id);
		}
	}, []);

	return (
		<>
			{onSubmit && (
				<div className="mx-auto !max-w-[480px]">
					<div className="z-[99999] fixed !max-w-[480px] h-full w-full overflow-hidden bg-[#1C274C] opacity-[86%]"></div>
					<div className="z-[99999] fixed !max-w-[480px] h-full w-full overflow-hidden flex flex-col items-center justify-center">
						<Lottie
							animationData={successAnimation}
							className="w-[268px]"
						/>
						<h1 className="text-white text-[18px] font-bold">
							Form berhasil dikirim
						</h1>
						<button
							className="flex items-center gap-4 my-8"
							onClick={() => navigator(`/admin/`)}
						>
							<img
								src="/assets/imgs/icon-arrow-left.svg"
								alt=""
							/>
							<p className="text-[16px] text-white">Back to home</p>
						</button>
					</div>
				</div>
			)}

			<Layout
				showNavBar={false}
				showNavigation={true}
			>
				{isLoading ? (
					<Loader />
				) : (
					<div className="mb-[7rem] mt-5 min-h-screen overflow-auto">
						<h1 className="text-base font-bold">{questioner?.name}</h1>
						<p className="text-sm my-2">{questioner?.description}</p>

						<div className="mt-[20px] mx-[10px]">
							<FormGroup label={'Pilih Trainer'}>
								<SelectDropDown
									options={trainerList}
									value={selectTrainer}
									onChange={(e: Toption) => {
										setSelectTrainer(e);
									}}
								/>
							</FormGroup>
							{questionnaireTransactionDetails &&
								questionnaireTransactionDetails.map(
									(item: any, index: number) =>
										item.questionnaireDetail.valueType == 'text' ? (
											<FormGroup
												label={`${item.questionnaireDetail.name}`}
												key={index}
											>
												<InputTextblock
													placeholder={`Tuliskan ${item.questionnaireDetail.name}`}
													value={item.valueText}
													onChange={(e) =>
														updateValueText(index, e.target.value)
													}
												/>
											</FormGroup>
										) : (
											<FormGroup
												label={`${item.questionnaireDetail.name}`}
												key={index}
											>
												<div className="w-full flex gap-2">
													{item.questionnaireDetail.valueText &&
														item.questionnaireDetail.valueText
															.split(';')
															.map((valueItem: any, indexValueItem: number) => (
																<RadioButton
																	key={indexValueItem}
																	value={valueItem}
																	checked={item.valueText === valueItem}
																	onChange={(e) => {
																		updateValueText(index, e.target.value);
																	}}
																	label={`${valueItem}`}
																/>
															))}
												</div>
											</FormGroup>
										)
								)}

							<div className="my-5 flex justify-between gap-4">
								<button
									className={`w-full px-[44px] py-[12px] text-[13px] rounded-[8px] hover:opacity-80 text-white bg-[#156CF7] ${isLoading && 'hover:cursor-not-allowed opacity-80'
										}`}
									onClick={() => handleSubmit()}
									disabled={isLoading}
								>
									{isLoading ? 'loading...' : 'Kirim'}
								</button>
							</div>
						</div>
					</div>
				)}
			</Layout>
		</>
	);
};

export default QuestionerEventForm;
